import { CatalogAccessDatesGroup, CatalogAccessEntityChange } from './types/catalogAccess.types';

const getDatesGroupKey = ({ startDate, endDate }: CatalogAccessEntityChange) =>
  `${startDate?.toISOString() ?? ''}|${endDate?.toISOString() ?? ''}`;

export const groupCatalogAccessChangesByDates = (
  changes: CatalogAccessEntityChange[],
): CatalogAccessDatesGroup[] => {
  const groupsByKey = new Map<string, CatalogAccessDatesGroup>();

  changes.forEach((change) => {
    const key = getDatesGroupKey(change);
    const group = groupsByKey.get(key);

    if (group) {
      group.entityIds.push(change.entityId);
      return;
    }

    groupsByKey.set(key, {
      entityIds: [change.entityId],
      startDate: change.startDate,
      endDate: change.endDate,
    });
  });

  return [...groupsByKey.values()];
};
